import Listagem from '../../componentes/Filiado/Relatorio/IntencaoVenda/listagem';

function RelatorioFiliadoIntencaoVenda() {
  return (
    <Listagem></Listagem>
  );
}

export default RelatorioFiliadoIntencaoVenda;
